var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-modal',{staticClass:"modal",attrs:{"name":"markdown-document","width":750,"height":"auto","scrollable":"","close-button":""},on:{"before-open":function($event){_vm.content = $event.params}}},[_c('v-markdown',{attrs:{"content":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }